module.exports = __webpack_public_path__ + "static/Gail-c10a69016e78725f0ded8f0765bc9270.jpg";